import React from "react";

const SvgAlignCenterIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 100 80"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="clip-Center">
          <path d="M0 0h100v80H0z" />
        </clipPath>
      </defs>
      <g id="Center" clip-path="url(#clip-Center)">
        <g id="center-align">
          <g id="Group_19840" data-name="Group 19840">
            <g id="Group_19839" data-name="Group 19839">
              <path
                id="Path_38517"
                d="M3.124 37.595h93.715a3.124 3.124 0 100-6.248H3.124a3.124 3.124 0 100 6.248z"
                data-name="Path 38517"
                transform="translate(0 -31.347)"
              />
              <path
                id="Path_38518"
                d="M50.144 114.939a3.124 3.124 0 100 6.248h65.6a3.124 3.124 0 100-6.248z"
                data-name="Path 38518"
                transform="translate(-32.963 -90.355)"
              />
              <path
                id="Path_38519"
                d="M96.839 198.531H3.124a3.124 3.124 0 100 6.248h93.715a3.124 3.124 0 100-6.248z"
                data-name="Path 38519"
                transform="translate(0 -149.363)"
              />
              <path
                id="Path_38520"
                d="M131.5 282.122H89.328a3.124 3.124 0 100 6.248H131.5a3.124 3.124 0 000-6.248z"
                data-name="Path 38520"
                transform="translate(-60.432 -208.37)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgAlignCenterIcon;
